var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "nav-utils",
      class: { "is-active--utils": this.isActiveUtils },
    },
    [
      _c("h2", { staticClass: "a11y" }, [_vm._v("사용자 메뉴")]),
      _vm._v(" "),
      !this.isAuthorized
        ? _c("div", { staticClass: "nav-utils__links" }, [
            _c(
              "a",
              {
                staticClass: "nav-utils__item",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.signIn($event)
                  },
                },
              },
              [_c("icon-sign-in", { staticClass: "icon" }), _vm._v("로그인 ")],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "nav-utils__item",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.signUp($event)
                  },
                },
              },
              [
                _c("icon-sign-up", { staticClass: "icon" }),
                _vm._v("회원가입 "),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "nav-utils__item nav-utils--faq",
                attrs: { href: "/info/cs/faq" },
              },
              [_c("icon-faq", { staticClass: "icon" }), _vm._v("FAQ ")],
              1
            ),
          ])
        : _c("div", { staticClass: "nav-utils__panel" }, [
            _c(
              "label",
              {
                staticClass: "nav-utils__item nav-utils__user",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.activateMenu($event)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "/me" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.trackGoingToMypage($event)
                      },
                    },
                  },
                  [
                    _c("icon-user-symbol", { staticClass: "icon icon--user" }),
                    _vm._v(" "),
                    _c("em", { staticClass: "em" }, [
                      _vm._v(_vm._s(_vm.userName)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("i", [_vm._v(" 님도, ")]),
                _vm._v(" "),
                _c("mark", [_vm._v(" 배우면 바뀐다 ")]),
                _vm._v(" "),
                _c("icon-triangle", { staticClass: "icon icon--triangle" }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "nav-utils__menu",
                attrs: { id: "nav-utils__menu" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "nav-utils__a",
                      attrs: { href: "/me" },
                      on: { click: _vm.trackGoingToMypage },
                    },
                    [_vm._v("\n          내 강의 보기\n        ")]
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
              ]
            ),
          ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { staticClass: "nav-utils__a", attrs: { href: "/me/enrolled" } },
        [_vm._v("수강 신청 내역")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { staticClass: "nav-utils__a", attrs: { href: "/me/payment/paid" } },
        [_vm._v("거래 내역")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }